var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegocios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graph-9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1010 811.666",
    enableBackground: "new 0 0 1010 811.666",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph-9-graph-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "62.1182,749.5273 62.1182,91.3999 0,91.3999 0,749.5273 0,811.666 62.1182,811.666 1010,811.666  1010,749.5273  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M247.0752,400.3672c0-23.7129-19.398-43.1519-43.1519-43.1519h-53.9194 c-23.7026,0-43.0898,19.439-43.0898,43.1519v308.4326h140.1611V400.3672z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M373.0479,270.9116c-23.7027,0-43.1211,19.3975-43.1211,43.1519v394.7363h140.1201V314.0635 c0-23.7544-19.3565-43.1519-43.1109-43.1519H373.0479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M596.0508,357.2153c-23.7129,0-43.1524,19.439-43.1524,43.1519v308.4326h140.1621V400.3672 c0-23.7129-19.3574-43.1519-43.0908-43.1519H596.0508z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M872.9619,184.5669H819.043c-23.713,0-43.1309,19.439-43.1309,43.1518v481.0811h140.1817V227.7187 C916.0938,204.0059,896.6953,184.5669,872.9619,184.5669z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M199.1357,302.145l205.8648-165.456l189.2212,169.0727c4.1103,3.6577,9.2471,5.4658,14.4043,5.4658 c5.4043,0,10.7881-2.0136,14.9599-6.041L852.7422,83.9204l46.0898,46.0283h11.918V0H780.7813v11.9184l41.4667,41.4668 L608.0303,260.2266L420.1245,92.3042c-7.8906-7.0689-19.6548-7.3565-27.915-0.7398L172.1143,268.5278 c-9.3086,7.48-10.7984,21.0415-3.3394,30.3706C176.2754,308.1455,189.8477,309.625,199.1357,302.145z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegocios);
export default __webpack_public_path__ + "static/media/negocios.d1bce1b168ef02ba4e0c9180b5e6af20.svg";
export { ForwardRef as ReactComponent };